module.exports = __webpack_public_path__ + "img/floppy-green.59b13db0.svg";